/* eslint-disable */
import React, { useContext, useEffect, useState, useRef } from 'react';
import { useTour } from '@reactour/tour';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesLeft } from '@fortawesome/free-solid-svg-icons';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { Filters } from './contexts';
import MoneyReport from './MoneyReport';
// import PeopleReport from './PeopleReport';
// import CustomersReport from './CustomersReport';
// import AuditReport from './AuditReport/AuditReport';
import Dropzone from './InsufficientReportAnnual/DropzoneComponentForInsufficientReportAnnual';
import InsufficientReport from './InsufficientReportAnnual/InsufficientReport';
import mountNotifications from '../utils/MountNotifications';
import ExportDropdown from './utils/ExportDropdown';
import ExportPDFandPrint from '../ExportPDFandPrint';

const Report = (props) => {
  const { filters } = useContext(Filters);
  const componentRefs = useRef();
  const { isOpen, currentStep, steps, setIsOpen, setCurrentStep } = useTour();
  const [fdu, setFdu] = useState('');
  const [activePopover, setActivePopover] = useState(null);
  const subdomain = props.subdomain
  const pageViewTitle = props.page === 'money' ? 'Reporting' : 'Analysis'

  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
    if (props.tourData.tracker_id && !props.tourData.tour_taken) {
      setIsOpen(true);
    } else if (
      (props.page === 'money' || props.page === 'analysis') &&
      props.tourData.tracker_id &&
      !props.tourData.new_features_tour_taken
    ) {
      setCurrentStep(22);
      setIsOpen(true);
    }
  }, []);

  const handleMouseEnter = (item) => {
    setActivePopover(item);
  };

  const handleMouseLeave = (item) => {
    if (item === 'leave') {
      setActivePopover(null);
    }
  };

  if (props.pending_calcs) {
    subscribe();
  }

  const notify = (message) => {
    mountNotifications()(message);
  };

  const subscribe = () => {
    if (modalData) {
      App[`job_${modalData.id}`] = App.cable.subscriptions.create(
        {
          channel: 'JobsChannel',
          job_type: 'CompanyCalculationWorker',
        },
        {
          received: (res) => {
            if (res.error) {
              console.log(res);
            } else if (res.finish) {
              mountNotifications(`Calculations Finished for ${modalData.name}`);
              updateStep(modalData.id);
            }
          },
        }
      );
    }
  };

  const hrefBuilder = (subdomain, path) => {
    const domainSplit = document.location.host.split('.');
    domainSplit[0] = subdomain;
    return `${location.protocol}//${domainSplit.join('.')}${path}`;
  };

  const addFdu = (fdu) => {
    setFdu(fdu);
  };

  const updateStep = (id) => {
    fetch(`/companies/${id}/step`).then((response) => response.json());
  };

  const InsufficientData = () => {
    return (
      <div className='insufficient-data'>
        <h3 className='text-center' id={`money-insufficient-data`}>
          You do not have sufficient data to generate a{' '}
          <strong>
            {props.year} report
          </strong>
          .
          <br />
          <br />
        </h3>
        {props.userType !== 'Freemium' ? (
          <h3 className='text-center'>
            Please prepare a <strong>{props.year} trial balance</strong> and upload or drag and drop
            the file below. Then you can map your file. You can also connect to QuickBooks Online.
          </h3>
        ) : (
          <h3 className='text-center'>
            Please prepare a <strong>{props.year} trial balance</strong>. You can connect to
            QuickBooks Online and then map your file.
          </h3>
        )}
        <div
          className='collapse in'
          id='collapseDropZone'
          role='region'
          aria-labelledby='Dropzone area to upload excel files, map files, or connect to quickbooks'
        >
          <div className='card card-body'>
            {props.userType !== 'Freemium' ? (
              <Dropzone
                calendarYearEnd={props.calendarYearEnd}
                fiscalYearEnd={props.fiscalYearEnd}
                name={props.name}
                subdomain={subdomain}
                id={props.id}
                notify={notify}
                addFdu={addFdu}
                hrefBuilder={hrefBuilder}
                fdu={fdu}
              />
            ) : null}
            <InsufficientReport {...props} fdu={fdu} />
          </div>
        </div>
      </div>
    );
  }

  function renderReport(page = props.page) {
    const Component = {
      money: MoneyReport,
    }['money'];
    // analysis and money are same at the moment

    if (props.insufficientData) return <InsufficientData />;

    return (
      <Component
        ref={componentRefs}
        key={'money-report-container'}
        {...props}
        year={props.year}
        yearRange={props.yearRange}
        page='money'
      />
    );
  }

  return (
    <div className='money-report-component'>
      <div id='notification-container-target' />
      <div id={`client-modal-${props.id}`} />
      <div id='sticky-topnav-left-btns'>
        {['money', 'analysis', 'people', 'customers'].includes(props.page) ? (
          <ExportPDFandPrint
            {...props}
            entityType={props.entityType}
            planAccess={props.planAccess}
            year={props.year}
            yearRange={props.yearRange}
          />
        ) : null}
        <ExportDropdown
          {...props}
          xlsx={['money', 'analysis', 'audit', 'kfi', 'planning'].includes(props.page)}
          printRef={componentRefs}
          planAccess={props.planAccess}
        />
      </div>
      <div id='sticky-topnav-right-btns'>
        <button className='hide-on-print' onClick={() => setIsOpen(true)}>
          <FontAwesomeIcon icon={faQuestionCircle} />
        </button>
      </div>
      <div id='sticky-side-btns'>
        <span
          className='filters-btn-span hide-on-print'
          onMouseEnter={() => handleMouseEnter('filters')}
          onMouseLeave={() => handleMouseLeave('leave')}
        >
          <button className='filters-btn'>
            <FontAwesomeIcon icon={faAnglesLeft} onClick={() => props.openFiltersModal()} />
          </button>
          {activePopover === 'filters' && <div className='filters-popover'>Display Filters</div>}
        </span>
      </div>
      <div className='report-view-name-and-form'>
        <span>{`${pageViewTitle} View:`}</span>
        <span>{props.templateReportView ? props.templateReportView?.name : props.activeReportView?.name}</span>
        {props.userId === props.templateReportView?.user_id && props.activeReportView?.name !== "My Default View" ? <button onClick={() => props.handleReportViewEditModal('edit')}>Edit View</button> : null}
        <button onClick={() => props.handleReportViewEditModal('create')}>+ Save New View</button>
      </div>
      {props.insufficientPeerData && filters.compare_with === 'Trailing 12' ? (
        <p style={{ textAlign: 'center' }}>
          Warning! Missing some monthly data in this report period for the Peers.
        </p>
      ) : null}
      {renderReport()}
    </div>
  );
}

export default Report;
